import routes from './routes';

export default routes;
export * from './Pages/index';
export * from './Components/index';
export * from './Providers/index';
export * from './hooks/index';
export * from './api/index';
